import React from "react";
import ReactDOM from "react-dom/client";
import "./App/index.css";
import App from "./App/App";
import "@fontsource/montserrat";
import "bootstrap/dist/css/bootstrap.min.css";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
